export const PRODUCTS_URL = '/products/product?code=';

export const getProductUrl = (code: string) => `${PRODUCTS_URL}${code}`;
